// libs
import React, { memo } from 'react';
import XmlToSvg from '@tencent/xml-to-svg';
import cns from 'classnames';
import isEqual from 'lodash/isEqual';

// styles
import styles from './index.less';

// constants
// TODO 待优化 1、路径的默认样式，2、添加起始点标识符
const PATH_STYLE = {
    fill: 'none',
    stroke: 'black',
    strokeWidth: 1,
    opacity: 0,
};

interface IProps {
    pathList?: [];
    scaleX: number;
    scaleY: number;
    translateX: number;
    translateY: number;
    styleObj?: { [key: string]: string | number };
    className?: string;
    componentKey?: string;
    setPathRef: (key, ref) => void;
}

const AnimSvg = (props: IProps) => {
    const { pathList = [], styleObj = {}, className = '', scaleX, scaleY, translateX, translateY, componentKey, setPathRef } = props;


    if (!pathList.length) return null;
    const getFinalPathStr = (path: string): {[key: string]: string} => {
        const xts = new XmlToSvg(path).scale(scaleX, scaleY)
            .serialize();
        return {
            scalePathStr: xts.serializeStr,
            translatePathStr: xts.translate(translateX, translateY).serializeStr,
        };
    };

    return (
        <div className={cns(styles['anim-svg'], className)} style={styleObj}>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ width: '100%', height: '100%' }}>
                <g>
                    {pathList?.map(({ path, id }) => {
                        const pathObj = getFinalPathStr(path);
                        const pathKey = `${componentKey}-path-${id}`;

                        return (
                            <React.Fragment key={pathObj.scalePathStr}>
                                {/* 该path用于展示 */}
                                <path
                                    d={pathObj.translatePathStr}
                                    style={PATH_STYLE}
                                >
                                </path>
                                {/* 该path用于播放 */}
                                <path
                                    d={pathObj.scalePathStr}
                                    style={{ visibility: 'hidden' }}
                                    ref={(el) => {
                                        setPathRef(pathKey, el);
                                    }}>
                                </path>
                            </React.Fragment>
                        );
                    })}
                </g>
            </svg>
        </div>
    );
};

export default memo(AnimSvg, (prevProps, nextProps) => isEqual(prevProps, nextProps));
